import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText, Icon } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './engineBoxDate.js';
import { CSSTransition } from 'react-transition-group';
import moment from 'moment';


class EngineBoxDate extends React.Component {
  static displayName = 'EngineBoxDate';

  constructor(props) {
    super(props);
    this.cx = props.theme.bind();
  }
  
  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  toggleBox = () => {
    const {
      toggleBox,
    } = this.props.config;

    let toggleBoxFn = toggleBox(null, 'datepicker')
    return toggleBoxFn
  }

  showElements = () => {

    const { config, theme } = this.props;
    const {
      visibleType,
      start,
      end,
      engineMerged
    } = config;
    const { classes } = theme.styles;

    // VERIFICAR SI START Y END SON MISMO MES
    const sameMonth = start && end && moment(start).format('MM') === moment(end).format('MM');

    return (
      <div className={[classes.dateBoxContent, this.cx({ engineMerged: engineMerged })].join(' ')}>
        <div
          className={[
            classes.inOutDate,
            this.cx({
              selectedDate: visibleType !== 'datepicker' && start && end
            })
          ].join(' ')}>
          {!start && (
            <RichText
              translate={true}
              text={'_%entrada%_'}
              ucFirst={true}
            />
          )}
          {start && (<RichText
              text={moment(start).format(sameMonth ? 'ddd, D' : 'ddd, D MMM').replace(/\./g, '')}
              innerStyle={classes.dateText}
            />
          )}
        </div>
        <div className={classes.dateSeparator}> · </div>
        <div
          className={[
            classes.inOutDate, classes.inOutDateEnd,
            this.cx({
              selectedDate: visibleType !== 'datepicker' && !start && end
            })
          ].join(' ')}>
          {!end && (
            <RichText
              translate={true}
              text={'_%salida%_'}
              ucFirst={true}
            />
          )}
          {end && (
            <RichText
              text={!!end && moment(end).format('ddd, D MMM').replace(/\./g, '')}
              innerStyle={classes.dateText}
            />
          )}
        </div>
      </div>
    )
  }

  handleKeyPress = (e) => {
    const { key } = e;
  
    if (key === 'Enter' || key === ' ') {
      e.preventDefault();
      this.toggleBox()();
    }
  };

  render() {
    const { config, theme } = this.props;

    const {
      visibleType,
      dropDown,
      showModalView,
      modalBreak
    } = config;
    const { classes } = theme.styles

    
    //Desktop version
    if(!modalBreak){
      //extraFields for portalDesing
      const extraLabelText = theme.theme === 'portalDesign' ? (
        <RichText
              translate={true}
              text={'_%¿Cuándo?%_'}
              ucFirst={true}
              innerStyle={classes.inputEngineTitle}
            />
      ) : null;

      return (<div onClick={this.toggleBox()} onKeyDown={this.handleKeyPress}
      className={[theme.computedInnerStyle].join(' ')} tabIndex={0} role='button' id='boxDate'>
        <div className={[classes.dateContainer, this.cx({dateContainerDispo: config.inAvail})].join(' ')}>
          {extraLabelText}
          
          <Icon unicodeContent={'e151'} innerStyle={classes.iconsEngine} />
          {this.showElements()}
        </div>
      </div>)
    }

   
    //Not desktop version

    //extraFields for portalDesing
    const extraLabelText = theme.theme === 'portalDesign' && !showModalView ? (<RichText
        translate={true}
        text={'_%¿Cuándo quieres ir?%_'}
        ucFirst={true}
        innerStyle={classes.inputEngineTitle}
      />) : null
    
      return (<CSSTransition
        in={visibleType === 'datepicker' || !dropDown}
        timeout={300}
        mountOnEnter
        unmountOnExit
        classNames={{
          enter: classes.inputEnter,
          enterActive: classes.inputEnterActive,
          exit: classes.inputLeave,
          exitActive: classes.inputLeaveActive
        }}>
        <div onClick={this.toggleBox()} onKeyDown={this.handleKeyPress} className={[theme.computedInnerStyle, this.cx({dispoModal:showModalView})].join(' ')} tabIndex={0} role='button' id='boxDate'>
          <div className={classes.dateContainer}>
            {extraLabelText}
            <Icon unicodeContent={'e151'} innerStyle={classes.iconsEngine} />
            {!extraLabelText && this.showElements()}
          </div>
        </div>
      </CSSTransition>);
    
  }

}

export default compose(
  PropertyManager([
    'visibleType',
    'start',
    'end',
    'dropDown',
    'showModalView',
    'toggleBox',
    'modalBreak',
    'inAvail',
    'engineMerged'
  ]),
  withThemeJSS({ styleFile, link: true, index: 100 }),
  withContent('i18n')
)(EngineBoxDate);
